import request from '../../api/request';

import {
  CreditLiquidationFormDataResponse,
  CreditLiquidationFilter,
  LiquidationPreviewResponse,
  ExecuteLiquidationRequest,
  ExecuteLiquidationResponse,
  UpdateCreditsRequest,
  UpdateCreditsResponse,
  LiquidationVersionSummary,
} from './types';

const CREDIT_LIQUIDATION_INITIAL = {
  FORM_DATA: '/maintainers-portal/credit-liquidation-initial/form',
  PREVIEW: '/maintainers-portal/credit-liquidation-initial/preview',
  EXECUTE: '/maintainers-portal/credit-liquidation-initial/execute',
  UPDATE_CREDITS: '/maintainers-portal/credit-liquidation-initial/credits',
  HISTORY: '/maintainers-portal/credit-liquidation-initial/history',
  LATEST_VERSION:
    '/maintainers-portal/credit-liquidation-initial/latest-version',
  EXPORT: '/maintainers-portal/credit-liquidation-initial/export',
};

export function getCreditLiquidationFormData() {
  return request<CreditLiquidationFormDataResponse>(
    CREDIT_LIQUIDATION_INITIAL.FORM_DATA,
  );
}

export function getCreditLiquidationPreview(params: CreditLiquidationFilter) {
  return request<LiquidationPreviewResponse>(
    CREDIT_LIQUIDATION_INITIAL.PREVIEW,
    {
      params,
    },
  );
}

export function executeCreditLiquidation(data: ExecuteLiquidationRequest) {
  return request<ExecuteLiquidationResponse>(
    CREDIT_LIQUIDATION_INITIAL.EXECUTE,
    {
      method: 'POST',
      data,
    },
  );
}

export function updateStudentCredits(data: UpdateCreditsRequest) {
  return request<UpdateCreditsResponse>(
    CREDIT_LIQUIDATION_INITIAL.UPDATE_CREDITS,
    {
      method: 'PATCH',
      data,
    },
  );
}

export function getLiquidationHistory(periodId: number) {
  return request<LiquidationVersionSummary[]>(
    CREDIT_LIQUIDATION_INITIAL.HISTORY,
    {
      params: { periodId },
    },
  );
}

export function getLatestLiquidationVersion(periodId: number) {
  return request<LiquidationVersionSummary | null>(
    CREDIT_LIQUIDATION_INITIAL.LATEST_VERSION,
    {
      params: { periodId },
    },
  );
}

export async function downloadLiquidationExcel(periodId: number) {
  const response = await request<Blob>(CREDIT_LIQUIDATION_INITIAL.EXPORT, {
    params: { periodId },
    responseType: 'blob',
  });

  if (response.error) {
    throw new Error('Error al descargar el archivo');
  }

  // Crear blob y descargar
  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute(
    'download',
    `liquidacion-creditos-inicio-periodo-${periodId}.xlsx`,
  );
  link.click();
  window.URL.revokeObjectURL(url);
}

export async function downloadVersionExcel(
  versionId: number,
  periodId: number,
) {
  const response = await request<Blob>(
    `${CREDIT_LIQUIDATION_INITIAL.HISTORY}/${versionId}/download`,
    {
      params: { periodId },
      responseType: 'blob',
    },
  );

  if (response.error) {
    throw new Error('Error al descargar el archivo');
  }

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute(
    'download',
    `liquidacion-creditos-inicio-version-${versionId}.xlsx`,
  );
  link.click();
  window.URL.revokeObjectURL(url);
}
